import React from "react";
import { ArrowLeft, Download } from "lucide-react";
import * as Option from "@utils/Option";

import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";
import { ok } from "@ps-bridge/ok";
import * as IO from "@ps-bridge/interop/io";
import NewSectionModalPanel from "@view/panels/document/review/NewSectionModal.panel";
import ReviewSectionsPanel from "@view/panels/document/review/ReviewSections.panel";
import * as styles from "@styles/Review.css";

const ReviewView: React.FC<DocumentReviewViewProps> = ({
    onBack,
    onOpenModal,
    onDownload,
    reviewSectionsPhase,
    handleDraft,
    handleRefine,
    handleEdits,
    handleUpload,
    newSectionModalPhase,
    closeModal,
    newSectionTitle,
    setNewSectionTitle,
    sectionTitleErrorPhase,
    sectionTitleErrorMessage,
    handleSubmitNewSection,
}) => {
    return (
        <div data-testid="page-review" data-page-state="ready">
            <div className={styles.buttonContainer}>
                <button
                    className={styles.backButton}
                    data-testid="review-back"
                    onClick={() => IO.run(onBack(ok))}
                >
                    <ArrowLeft size={16} className={styles.backIcon} />
                    Back
                </button>
                <div className={styles.buttonContainerSecond}>
                    <button
                        className={styles.button}
                        data-testid="review-open-new-section-modal"
                        onClick={() => IO.run(onOpenModal(ok))}
                    >
                        <span className={styles.buttonText}>Append New Section</span>
                    </button>
                    <button
                        className={styles.actionButton}
                        data-testid="review-download"
                        onClick={() => {
                            const action = Option.fold(onDownload, () => undefined, (value) => value);
                            if (action) {
                                IO.run(action(ok));
                            }
                        }}
                    >
                        <Download size={16} className={styles.icon} />
                        <span className={styles.actionButtonText}>Download</span>
                    </button>
                </div>
            </div>
            <ReviewSectionsPanel
                phase={reviewSectionsPhase}
                handleDraft={handleDraft}
                handleRefine={handleRefine}
                handleEdits={handleEdits}
                handleUpload={handleUpload}
            />
            <NewSectionModalPanel
                phase={newSectionModalPhase}
                closeModal={closeModal}
                newSectionTitle={newSectionTitle}
                setNewSectionTitle={setNewSectionTitle}
                sectionTitleErrorPhase={sectionTitleErrorPhase}
                sectionTitleErrorMessage={sectionTitleErrorMessage}
                handleSubmitNewSection={handleSubmitNewSection}
            />
        </div>
    );
};

export default ReviewView;
